import React from "react";
import { classNames, hasOwnProperty } from "maven-lib/dist/utils/misc";

export type FooterProps = { dummy: boolean } | { children: React.ReactNode } | { copyright: true; position?: "FIXED" };

export function Footer(props: FooterProps) {
  const footer =
    hasOwnProperty(props, "dummy") && props.dummy ? (
      <div>&copy; JNPMEDI Inc.</div>
    ) : hasOwnProperty(props, "children") ? (
      <>{props.children}</>
    ) : hasOwnProperty(props, "copyright") ? (
      <>
        <div className={classNames("app-hybrid-footer-copyright", `--position-${String(props.position || "default").toLowerCase()}`)}>
          &copy; JNPMEDI Inc.
        </div>
      </>
    ) : undefined;

  return (
    <>
      {!!footer && (
        <div className={classNames("app-hybrid-footer", "dummy" in props && props.dummy && "app-hybrid-footer-dummy")}>{footer}</div>
      )}
    </>
  );
}
